import {useId} from 'react'

export default (overwriteId?: string, suffix = '') => {
  const generatedId = `${useId()}${suffix}`
  return overwriteId || generatedId
}
